// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import type { PointerEvent } from 'react';

// Whether a pointer event is the main button: the left mouse button, a single touch, a pen tip.
// The dashboard's rows and cards decide click-vs-drag on pointer events rather than click, so
// without this test a middle click (the browser's "open in a new tab") and, on Windows and in
// Firefox, a right click would open the project in the current tab and arm a drag.
export const isPrimaryPress = (event: PointerEvent): boolean => event.isPrimary && event.button === 0;

export default isPrimaryPress;
